module.exports = __webpack_public_path__ + "img/lucky_1920.26182df6.png";